export default "__VITE_ASSET__b36fee53__"